import {
    InputStatusColors,
    InputStatusBGColors,
    CampaignGoalEnum
} from '../constants/Enums';

export const DefaultInputStatus = () => {
    return {
        statusMessage: undefined,
        statusColor: InputStatusColors.DEFAULT,
        statusBGColor: InputStatusBGColors.DEFAULT
    };
};

export const SuccessInputStatus = () => {
    return {
        statusMessage: undefined,
        statusColor: InputStatusColors.GREEN,
        statusBGColor: InputStatusBGColors.GREEN
    };
};

export const ErrorInputStatus = (statusMsg) => {
    return {
        statusMessage: statusMsg,
        statusColor: InputStatusColors.RED,
        statusBGColor: InputStatusBGColors.RED
    };
};

export const getCampaignGoalDefaults = () => {
    return [
        { goal: CampaignGoalEnum.BUDGET, value: '', selected: true },
        { goal: CampaignGoalEnum.SPOTS, value: '', selected: false },
        { goal: CampaignGoalEnum.BASE, value: '', selected: false },
        { goal: CampaignGoalEnum.BASEREACH, value: '', selected: false },
        { goal: CampaignGoalEnum.TARGETREACH, value: '', selected: false },
        { goal: CampaignGoalEnum.TARGET, value: '', selected: false },
        { goal: CampaignGoalEnum.BASEOTH, value: '', selected: false },
        { goal: CampaignGoalEnum.TARGETOTH, value: '', selected: false },
        { goal: CampaignGoalEnum.OVERALLBASEOTH, value: '', selected: false },
        { goal: CampaignGoalEnum.OVERALLTARGETOTH, value: '', selected: false }
    ];
};

export const campaignStationsDictionaryToArray = (stationsDictionary) => {
    if (!stationsDictionary) {
        return [];
    }
    const stationKeys = Object.keys(stationsDictionary);
    const stationsArray = [];

    for (let i = 0; i < stationKeys.length; i++) {
        stationsArray.push(stationsDictionary[stationKeys[i]]);
    }

    return stationsArray;
};

export const campaignStationsArrayToDictionary = (stationsArray) => {
    const stationsDictionary = {};

    for (const i in stationsArray) {
        stationsDictionary[stationsArray[i].id] = stationsArray[i];
    }

    return stationsDictionary;
};

export const getGoalDescription = (goal) => {
    switch (goal) {
        case CampaignGoalEnum.BUDGET: {
            return window.translate('Budget');
        }
        case CampaignGoalEnum.WEEKLYBUDGET: {
            return window.translate('Budget');
        }
        case CampaignGoalEnum.BASEREACH: {
            return window.translate('Base Reach %');
        }
        case CampaignGoalEnum.TARGETREACH: {
            return window.translate('Target Reach %');
        }
        case CampaignGoalEnum.BASEOTH: {
            return window.translate('Base Weekly OTH');
        }
        case CampaignGoalEnum.TARGETOTH: {
            return window.translate('Target Weekly OTH');
        }
        case CampaignGoalEnum.OVERALLBASEOTH: {
            return window.translate('Base Overall OTH');
        }
        case CampaignGoalEnum.OVERALLTARGETOTH: {
            return window.translate('Target Overall OTH');
        }
        case CampaignGoalEnum.BASE: {
            return window.translate('Base Impacts');
        }
        case CampaignGoalEnum.TARGET: {
            return window.translate('Target Impacts');
        }
    }
};

export const getTotalDescription = (goal) => {
    switch (goal) {
        case CampaignGoalEnum.BASE:
        case CampaignGoalEnum.TARGET: {
            return window.translate('Total Available Impacts');
        }
        default:
          return window.translate('Total Available Value');
    }
};

export const getAllocatedDescription = (goal) => {
  switch (goal) {
      case CampaignGoalEnum.BASE:
      case CampaignGoalEnum.TARGET: {
          return window.translate('Allocated Impacts');
      }
      default:
        return window.translate('Allocated Budget');
  }
};


export const getUnallocatedDescription = (goal) => {
    switch (goal) {
        case CampaignGoalEnum.BASE:
        case CampaignGoalEnum.TARGET: {
            return window.translate('Unallocated Impacts');
        }
        default:
          return window.translate('Unallocated Budget');
    }
};

export const getGoalType = (goal) => {
    switch (goal) {
        case CampaignGoalEnum.BUDGET: {
            return window.translate('Total Budget');
        }
        case CampaignGoalEnum.WEEKLYBUDGET: {
            return window.translate('Weekly Budget');
        }
        case CampaignGoalEnum.BASEREACH: {
            return window.translate('Base');
        }
        case CampaignGoalEnum.TARGETREACH: {
            return window.translate('Target');
        }
        case CampaignGoalEnum.BASEOTH: {
            return window.translate('Base');
        }
        case CampaignGoalEnum.TARGETOTH: {
            return window.translate('Target');
        }
        case CampaignGoalEnum.OVERALLBASEOTH: {
            return window.translate('Base');
        }
        case CampaignGoalEnum.OVERALLTARGETOTH: {
            return window.translate('Target');
        }
        case CampaignGoalEnum.BASE: {
            return window.translate('Base');
        }
        case CampaignGoalEnum.TARGET: {
            return window.translate('Target');
        }
    }
};

export const sanitiseGoal = (campaignGoal) => {
    const updatedGoal = campaignGoal;
    for (let i = 0; i < campaignGoal?.length; i++) {
        // eslint-disable-next-line no-prototype-builtins
        if (campaignGoal[i].hasOwnProperty('Goal')) {
            campaignGoal[i].goal = campaignGoal[i].Goal;
            delete campaignGoal[i].Goal;
        }

        // eslint-disable-next-line no-prototype-builtins
        if (campaignGoal[i].hasOwnProperty('Value')) {
            campaignGoal[i].value = campaignGoal[i].Value;
            delete campaignGoal[i].Value;
        }

        // eslint-disable-next-line no-prototype-builtins
        if (campaignGoal[i].hasOwnProperty('Selected')) {
            campaignGoal[i].selected = campaignGoal[i].Selected;
            delete campaignGoal[i].Selected;
        }
    }

    return updatedGoal;
};

// Turns Reach goal into Base Reach/Target Reach - this is handling that we can remove once everyone has a new campaign to work with since 14 May
export const formatGoal = (campaignGoal) => {
    const updatedGoal = campaignGoal;
    const reachIdx = campaignGoal.findIndex((g) => g.goal === 'reach');
    if (reachIdx !== -1) {
        updatedGoal.splice(reachIdx, 0, {
            goal: CampaignGoalEnum.BASEREACH,
            value: '',
            selected: false
        });
        updatedGoal.splice(reachIdx + 1, 0, {
            goal: CampaignGoalEnum.TARGETREACH,
            value: '',
            selected: false
        });
        updatedGoal.splice(reachIdx + 2, 1);
    }

    // Need a method to add the missing goals to older campaigns without overwriting any values, at least while still using the older stuff
    if (campaignGoal.findIndex((g) => g.goal === 'budget') === -1) {
        updatedGoal.push({
            goal: CampaignGoalEnum.BUDGET,
            selected: false,
            value: ''
        });
    }
    if (campaignGoal.findIndex((g) => g.goal === 'weeklyBudget') === -1) {
        updatedGoal.push({
            goal: CampaignGoalEnum.WEEKLYBUDGET,
            selected: false,
            value: ''
        });
    }
    if (campaignGoal.findIndex((g) => g.goal === 'spotsPerWeek') === -1) {
        updatedGoal.push({
            goal: CampaignGoalEnum.SPOTS,
            selected: false,
            value: ''
        });
    }
    if (campaignGoal.findIndex((g) => g.goal === 'baseReach') === -1) {
        updatedGoal.push({
            goal: CampaignGoalEnum.BASEREACH,
            selected: false,
            value: ''
        });
    }
    if (campaignGoal.findIndex((g) => g.goal === 'targetReach') === -1) {
        updatedGoal.push({
            goal: CampaignGoalEnum.TARGETREACH,
            selected: false,
            value: ''
        });
    }
    if (campaignGoal.findIndex((g) => g.goal === 'weeklyBaseOTH') === -1) {
        updatedGoal.push({
            goal: CampaignGoalEnum.BASEOTH,
            selected: false,
            value: ''
        });
    }
    if (campaignGoal.findIndex((g) => g.goal === 'weeklyTargetOTH') === -1) {
        updatedGoal.push({
            goal: CampaignGoalEnum.TARGETOTH,
            selected: false,
            value: ''
        });
    }
    if (campaignGoal.findIndex((g) => g.goal === 'overallBaseOTH') === -1) {
        updatedGoal.push({
            goal: CampaignGoalEnum.OVERALLBASEOTH,
            selected: false,
            value: ''
        });
    }
    if (campaignGoal.findIndex((g) => g.goal === 'overallTargetOTH') === -1) {
        updatedGoal.push({
            goal: CampaignGoalEnum.OVERALLTARGETOTH,
            selected: false,
            value: ''
        });
    }
    if (campaignGoal.findIndex((g) => g.goal === 'baseImpacts') === -1) {
        updatedGoal.push({
            goal: CampaignGoalEnum.BASE,
            selected: false,
            value: ''
        });
    }
    if (campaignGoal.findIndex((g) => g.goal === 'targetImpacts') === -1) {
        updatedGoal.push({
            goal: CampaignGoalEnum.TARGET,
            selected: false,
            value: ''
        });
    }

    if (campaignGoal.findIndex((g) => g.selected) === -1) {
        campaignGoal[
            campaignGoal.findIndex((g) => g.goal === 'budget')
        ].selected = true;
    }

    campaignGoal.forEach(goal => {
        if (goal.values) {
            if (goal.value === -1) {
                goal.value = '-';
            }

            goal.values = JSON.parse(goal.values);
        }
    });

    return updatedGoal;
};

export const generateMonthlyPoNumbers = (
    startDate,
    endDate,
    currentNumbers = []
) => {
    const dateFrom = new Date(startDate);
    const dateTo = new Date(endDate);
    const startYear = dateFrom.getFullYear();
    const endYear = dateTo.getFullYear();
    const startMonth = dateFrom.getMonth();
    const endMonth = dateTo.getMonth();

    const campaignCalendarMonths =
        (endYear - startYear) * 12 + (endMonth - startMonth) + 1;

    const iterableDate = new Date(dateFrom.setMonth(dateFrom.getMonth() - 1));
    const monthlyPoNumbers = []; // currentNumbers;

    if (campaignCalendarMonths < currentNumbers.length) {
        monthlyPoNumbers.splice(campaignCalendarMonths);
    }

    iterableDate.setMonth(iterableDate.getMonth() + currentNumbers?.length);

    for (let i = 0; i < campaignCalendarMonths; i++) {
        const currentDate = new Date(startYear, startMonth + i, 1);

        const vl = currentNumbers[i]?.poNumber;
        monthlyPoNumbers.push({
            dateText: `${currentDate.toString().substring(4, 7)} ${currentDate
                .toString()
                .substring(11, 15)}`,
            date: new Date(
                currentDate.getFullYear(),
                currentDate.getMonth(),
                currentDate.getDay() + 1,
                0,
                0,
                0,
                0
            ),
            poNumber: vl
        });
    }

    return monthlyPoNumbers;
};
